export function safeHTML(htmlString) {
    const doc = document.implementation.createHTMLDocument('');
    const div = doc.createElement('div');

    div.innerHTML = htmlString;

    for (let elements = div.querySelectorAll('*'), i = elements.length - 1; i >= 0; i--) {
        const element = elements[i];
        const tagName = element.localName;

        if (tagName === 'script' || tagName === 'noscript' || tagName === 'noembed' || !(element.attributes instanceof NamedNodeMap)) {
            try {
                element.parentNode.removeChild(element);
            } catch (e) {
                element.outerHTML = '';
            }
            continue;
        }

        if (!element.hasAttributes()) { continue; }

        for (let attributes = element.attributes, j = attributes.length - 1; j >= 0; j--) {
            const attribute = attributes[j];
            const attributeName = attribute.localName;
            // eslint-disable-next-line no-control-regex
            const attributeValue = attribute.value.replace(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g, '').toLowerCase().trim();

            // Remove insecure attribute starting "on*" (example: <img src='' onerror=alert(1)>)
            // eslint-disable-next-line brace-style
            if (attributeName.indexOf('on') === 0) { element.removeAttribute(attributeName); }

            // Remove insecure src/href attribute with value starting "javascript:*" (example: href="javascript:alert(1)")
            // eslint-disable-next-line brace-style
            else if ((attributeName === 'src' || attributeName === 'href') && attributeValue.indexOf('javascript:') === 0) { element.removeAttribute(attributeName); }

            // For non-specific tags remove insecure src/data attribute with value starting "data:*" (example: <embed src="data:text/html;base64,PHNjcmlwdD5hbGVydCgxKTwvc2NyaXB0Pg==">)
            else if (['audio', 'image', 'img', 'source', 'video'].indexOf(tagName) === -1 && (attributeName === 'src' || attributeName === 'data') && attributeValue.indexOf('data:') === 0) { element.removeAttribute(attributeName); }
        }
    }

    return div.innerHTML;
}
